import { createContext } from 'react';

export type OnSubmitType = (values: Record<string, unknown>, validator, language: string) => void;

export const onSubmitContext = createContext<OnSubmitType | null>(null);
